import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const packages = [{
  name: 'STARTER',
  price: '1,899',
  desc: 'Essential brand identity for startups.',
  features: ['Logo Design (3 Concepts)', 'Color Palette System', 'Typography Selection', 'Basic Brand Guidelines', 'Social Media Kit'],
  highlight: false
}, {
  name: 'PROFESSIONAL',
  price: '4,499',
  desc: 'Complete brand system for growing businesses.',
  features: ['Everything in Starter', 'Stationery Design', 'Marketing Collateral', 'Web Design UI Kit', 'Extended Brand Book', '3D Logo Animation'],
  highlight: true
}, {
  name: 'ENTERPRISE',
  price: '9,999',
  desc: 'Full ecosystem for market leaders.',
  features: ['Everything in Professional', 'Custom Iconography Set', 'Motion Design System', 'Full Website Development', 'Copywriting Tone of Voice', 'Priority Support'],
  highlight: false
}];
export function Pricing() {
  return <section className="py-24 px-6 md:px-12 border-b-2 border-navy bg-white relative overflow-hidden" id="pricing" data-id="element-172">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gray-50 -z-10" data-id="element-173" />

      <div className="max-w-7xl mx-auto" data-id="element-174">
        <div className="flex items-baseline justify-between mb-16 border-b-2 border-navy pb-4" data-id="element-175">
          <h2 className="text-4xl md:text-6xl font-bold text-navy tracking-tight" data-id="element-176">
            PACKAGES
          </h2>
          <span className="font-mono text-sm text-coral" data-id="element-177">04 / INVESTMENT</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start" data-id="element-178">
          {packages.map((pkg, i) => <motion.div key={pkg.name} initial={{
          y: 50,
          opacity: 0
        }} whileInView={{
          y: 0,
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} whileHover={{
          y: -10
        }} className={`relative p-8 md:p-10 border-2 ${pkg.highlight ? 'border-coral bg-navy text-white shadow-[12px_12px_0px_0px_rgba(255,107,74,1)]' : 'border-navy bg-white text-navy hover:shadow-[8px_8px_0px_0px_rgba(10,22,40,1)]'} transition-all duration-300`} data-id="element-179">
              {pkg.highlight && <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-coral text-white px-4 py-1 font-mono text-xs font-bold uppercase tracking-widest" data-id="element-180">
                  Recommended
                </div>}

              <h3 className="font-mono text-sm tracking-widest uppercase mb-4 opacity-70" data-id="element-181">
                {pkg.name}
              </h3>

              <div className="flex items-baseline gap-2 mb-6" data-id="element-182">
                <span className="text-5xl md:text-6xl font-bold tracking-tighter" data-id="element-183">
                  {pkg.price}
                </span>
                <span className="font-mono text-sm" data-id="element-184">PLN</span>
              </div>

              <p className={`mb-8 text-lg leading-relaxed ${pkg.highlight ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-185">
                {pkg.desc}
              </p>

              <ul className="space-y-4 mb-10 font-mono text-sm" data-id="element-186">
                {pkg.features.map((feature, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-187">
                    <Check className={`w-5 h-5 flex-shrink-0 ${pkg.highlight ? 'text-coral' : 'text-navy'}`} data-id="element-188" />
                    <span className="opacity-90" data-id="element-189">{feature}</span>
                  </li>)}
              </ul>

              <button className={`w-full py-4 font-bold tracking-wide border-2 transition-colors ${pkg.highlight ? 'bg-coral border-coral text-white hover:bg-white hover:text-coral' : 'bg-navy text-white border-navy hover:bg-white hover:text-navy'}`} data-id="element-190">
                SELECT PLAN
              </button>
            </motion.div>)}
        </div>
      </div>
    </section>;
}